import { Footer } from "./footer/NewFooter";
import { Hero } from "./contact/components/Hero";
import ProviderNavigation from "../ProviderNavigation";
import ScrollToTop from "../ScrollToTop";
export default function ContactPage() {
  return (
    <div className="tw-relative tw-flex tw-min-h-screen tw-flex-col tw-bg-[#010A6F] tw-bg-[url('/landing_page_assets/backgrounds/bg2.jpg')] tw-bg-cover">
      <ScrollToTop />
      <ProviderNavigation isDark />
      <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-w-full tw-max-w-[1448px] tw-flex-1 tw-px-[20px] tw-pb-[64px]">
        <Hero />
      </div>
      <div className="tw-w-full">
        <Footer />
      </div>
    </div>
  );
}
